import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeErrorHandlers } from './utils/errorHandling';

// Initialize extension-compatible error handlers
initializeErrorHandlers();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// Service Worker Registration for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
        
        // Note: Automatic update checking removed to prevent page reloads
        // Updates will be checked when the page is refreshed manually
        
        // Handle updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New version available
                if (confirm('A new version is available. Would you like to update?')) {
                  window.location.reload();
                }
              }
            });
          }
        });
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}

// Error handling is now managed by the errorHandling utility

// PWA Install functionality is now handled by the PWAInstallButton component

reportWebVitals();